import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import styles from "./WeddingPagination.module.css";

const WeddingPagination = ({
  currentPage,
  setCurrentPage,
  totalItemsCount,
  itemsCountPerPage,
  paginationChange,
  setPaginationChange,
}) => {
  const [pagesToDisplay, setPagesToDisplay] = useState(8);
  const pageref = useRef();

  // Set number of pages to display based on window width
  useEffect(() => {
    const updatePagesToDisplay = () => {
      if (window.innerWidth > 750) {
        setPagesToDisplay(8);
      } else if (window.innerWidth > 470 && window.innerWidth <= 750) {
        setPagesToDisplay(4);
      } else {
        setPagesToDisplay(2);
      }
    };

    updatePagesToDisplay();
    window.addEventListener("resize", updatePagesToDisplay);
    return () => window.removeEventListener("resize", updatePagesToDisplay);
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPaginationChange({ ...paginationChange, page: pageNumber });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrevButtonClick = () => {
    if (paginationChange.page > 1) {
      const newPage = paginationChange.page - 1;
      setCurrentPage(newPage);
      setPaginationChange({ ...paginationChange, page: newPage });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNextButtonClick = () => {
    const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
    if (paginationChange.page < totalPages) {
      const newPage = paginationChange.page + 1;
      setCurrentPage(newPage);
      setPaginationChange({ ...paginationChange, page: newPage });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="custom-pagination-wedding">
      <p
        onClick={handlePrevButtonClick}
        className={
          paginationChange.page !== 1
            ? styles.prevButton
            : styles.prevButtonDisabled
        }
      >
        Prev
      </p>
      <Pagination
        ref={pageref}
        activePage={paginationChange.page}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pagesToDisplay}
        onChange={handlePageChange}
      />
      <p
        onClick={handleNextButtonClick}
        className={
          paginationChange.page !==
          Math.ceil(totalItemsCount / itemsCountPerPage)
            ? styles.nextButton
            : styles.nextButtonDisabled
        }
      >
        Next
      </p>
    </div>
  );
};

export default WeddingPagination;
